// extracted by mini-css-extract-plugin
export default {"recipe_body":"RecipeBody_recipe_body__lQfPp","image_blocker":"RecipeBody_image_blocker__38GeO","drink_image":"RecipeBody_drink_image__01pNg"};